/* eslint-disable func-names */
import { runQuery } from './fetchData';

const Data = (function () {
  let instance;
  let clients;
  let selectedClient;
  let user;

  function createInstance() {
    const object = {};
    return object;
  }

  const getClientsData = async function () {
    if (!clients) {
      const { data: response } = await runQuery(`
      query {
          user{
            id,
            firstName,
            clients{
              id,
              teams{
                id,
                name
              },
              
              id,
              name,
              users{
                id,
                firstName,
                middleName,
                lastName,
                phoneNumber,
                email,
                roles{
                  id,
                  name
                }
              },
              stats{
                projects,
                submissions,
                teams,
                users,
                fileUploads
              }
              invitations{
                id,
                user,
                time,
                role{
                  name
                }
              }
              teams{
                  id,
                  name,
                  users{
                      id,
                      firstName,
                      middleName,
                      lastName,
                      phoneNumber,
                      email
                  }
              }
              roles{
                id,
                name,
                users{
                  id,
                  firstName,
                  email
                }
              }
              projects{
                id,
                name,
                teams{
                  id,
                  name
                },
                questionnaire{
                  id,
                  name,
                  order,
                  pages{
                    id,
                    name,
                    groups{
                      id,
                      name,
                      questions{
                        id,
                        type,
                        contentType,
                        placeholder,
                        tag,
                        position,
                        validation,
                        conditional{
                          parent,
                          parentValue
                        }
                        options{
                          label,
                          value
                        },
                        sentences{
                          sentenceLabel,
                          sentenceValue
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }`);

      // eslint-disable-next-line no-undef
      const selectedItem = localStorage.getItem('selectedItem');

      selectedClient = response.user.clients.filter(
        fil => fil.id === selectedItem,
      )[0]
        ? response.user.clients.filter(fil => fil.id === selectedItem)[0]
        : response.user.clients[0];

      const {
        user: { clients: clientData },
      } = response;
      const { user: userInfo } = response;

      user = userInfo;
      clients = clientData;

      return clientData;
    }

    return clients;
  };

  return {
    getInstance() {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
    async getUserData() {
      if (!user) {
        await getClientsData();
        return user;
      }
      return user;
    },
    async getClientData() {
      if (!selectedClient) {
        await getClientsData();
        return selectedClient;
      }
      return selectedClient;
    },
    getClientsData: async () => getClientsData(),
    async changeSelectedClientData({ id }) {
      selectedClient = clients.filter(c => c.id === id).pop();
    },
  };
}());

export default Data;
